<template>
	<div v-once id="font_purchase">
		<section class="hero">
			<div class="hero__title">
				<h2 class="h2">폰트 구입에 대하여</h2>
			</div>
		</section>
		<div class="attention wrapper">
			<p class="attention__txt">현재 제공하는 기본 글꼴은 계속 무료로 사용하실 수 있습니다.<br>
				많은분이 요청하신 "내일 아침체"와 "고딕체"도 포함해, <br class="pc"> 글꼴 선택 기능은 반년동안 무료로 제공된뒤 유료화 됩니다.</p>
		</div>
		<section class="second">
			<h2 class="h2">선택할 수 있는 글꼴</h2>
			<div class="fontlist wrapper">
				<div class="fontlist__default">
					<p>디폴트(고딕)</p>
					<img src="/kr/resume/static/renew_img/font_lp_img/font_01.png" alt="Noto Sans JP"
						class="fontlist__shadow">
				</div>
				<div class="fontlist__02 sp-flex">
					<div class="font_block">
						<p>고딕</p>
						<img src="/kr/resume/static/renew_img/font_lp_img/font_02.png" alt="yagish고딕"
							class="fontlist__shadow">
						<img src="/kr/resume/static/renew_img/font_lp_img/font_03.png" alt="Kosugi"
							class="fontlist__shadow">
					</div>
					<div class="font_block">
						<p>명조</p>
						<img src="/kr/resume/static/renew_img/font_lp_img/font_04.png" alt="Noto Serif JP"
							class="fontlist__shadow">
						<img src="/kr/resume/static/renew_img/font_lp_img/font_05.png" alt="yagish명조"
							class="fontlist__shadow">
						<img src="/kr/resume/static/renew_img/font_lp_img/font_06.png" alt="Klee One"
							class="fontlist__shadow">
					</div>
				</div>
				<div class="fontlist__03 sp-flex">
					<div class="font_block">
						<p>손글씨</p>
						<img src="/kr/resume/static/renew_img/font_lp_img/font_07.png" alt="Kiwi Maru"
							class="fontlist__shadow">
						<img src="/kr/resume/static/renew_img/font_lp_img/font_08.png" alt="Zen Kurenaido"
							class="fontlist__shadow">
					</div>
					<div class="font_block">
						<p>개성적!?</p>
						<img src="/kr/resume/static/renew_img/font_lp_img/font_09.png" alt="도트 고딕 16"
							class="fontlist__shadow">
					</div>
				</div>
			</div>
			<div class="fontmemo wrapper">
				<div class="fontmemo__block">
					<p class="fontmemo__title">글꼴의 종류가 늘어나도,<br>추가구매 없이 사용할 수 있습니다.</p>
					<p class="fontmemo__txt">※향후 서비스 확대로 폰트가<br>늘어날 가능성이 있어요。</p>
				</div>
			</div>
			<div class="cv-block wrapper">
				<p>＼2200원으로 모두 사용할 수 있습니다.／</p>
				<el-button class="cv-btn cv-btn--red cv-btn--radius cv-btn--cubic" @click="openFontDialog">폰트팩<span
						class="cv-btn_small">을 구입</span></el-button>
			</div>
		</section>

		<!--使い方-->
		<section class="third">
			<div class="wrapper">
				<h2 class="h2">이용방법</h2>
				<ul class="step">
					<li class="step_item">
						<div class="sp-flex step_center">
							<p class="step_number">①</p>
							<p><span class="step_bold">작성중인 화면 아래의 '미리보기'</span>를 클릭！</p>
						</div>
						<img src="/kr/resume/static/renew_img/font_lp_img/step_01.png" alt="작성중인 화면 아래의 미리보기를 클릭">
					</li>
					<li class="step_item">
						<div class="sp-flex step_center">
							<p class="step_number">②</p>
							<p><span class="step_bold">미리보기 화면의 '폰트 변경'</span>버튼 클릭！</p>
						</div>
						<img src="/kr/resume/static/renew_img/font_lp_img/step_02.png" alt="미리보기 화면의 폰트 변경 버튼클릭">
					</li>
					<li class="step_item">
						<div class="sp-flex step_item_03">
							<p class="step_number">③</p>
							<p><span class="step_bold">신용카드 정보를 입력하고</span>구입버튼클릭！<br>
								<span class="step_small">※고객님의 카드정보는 저장되지 않습니다.</span>
							</p>
						</div>
						<img src="/kr/resume/static/renew_img/font_lp_img/step_03.png" alt="신용카드 정보를 입력하고 구입 버튼클릭">
					</li>
					<li class="step_item">
						<div class="sp-flex step_center">
							<p class="step_number">④</p>
							<p><span class="step_bold">글꼴을선택하고、</span>선택한 글꼴로 변경 버튼을 클릭!<br>
								<span class="step_small">※녹색 변경 버튼을 누르지 않으면 이력서에 반영되지 않습니다.</span>
							</p>
						</div>
						<img src="/kr/resume/static/renew_img/font_lp_img/step_04.png" alt="글꼴을선택하고、선택한 글꼴로 변경 버튼을 클릭!">
						<img src="/kr/resume/static/renew_img/font_lp_img/deco02.png" alt="글꼴을 선택해 주었으면 하는 야기"
							class="deco02">
					</li>
				</ul>
			</div>
			<div class="cv-block wrapper">
				<p>＼2200원으로 사용 할 수 있어요.／</p>
				<el-button class="cv-btn cv-btn--red cv-btn--radius cv-btn--cubic" @click="openFontDialog">폰트팩<span
						class="cv-btn_small">을 구입</span></el-button>
				<p class="memo">※미리보기 화면에서 이용할 수 있습니다.</p>
			</div>
		</section>

		<div style="text-align: center; padding: 20px;">
			<a href="/kr/resume/terms" target="_blank">이용약관은<span style="color: #E3165C;">이쪽</span></a>
		</div>
	</div>
</template>

<style lang="css" src="@/assets/css/font_lp_stylesheet.css"></style>


<script>

export default {
	data: function () {
		return {
		}
	},
	computed: {},
	methods: {
		openFontDialog: function () {
			const app = this
			if (this.$firebase.isAuthenticated) {
				const formData = new FormData()
				formData.append('uuid', this.$firebase.user.uid)

				this.$axios
					.post(this.$varuna.endPoints.getFontpayment, formData, { timeout: 60000 })
					.then(function (response) {
						if (response.data.payment_flag == '1') {
							app.$message({
								message: '이미 구입하셨습니다.이용 해주세요.',
								type: 'warning'
							})
						} else {
							app.$eventHub.$emit('open-fontpayment-dialog', 'lp')
						}
					})
					.catch(function (error) {
					}).finally(function () {
					})

			} else {
				app.$message({
					message: '회원가입이 필요합니다.로그인 해주세요.',
					type: 'warning'
				})
			}
		},
		getFontpayment: function () {

			this.$nextTick(function () {
				console.error(this.$firebase)
				console.error(this.$firebase.isAuthenticated)
				if (this.$firebase.isAuthenticated) {
					const app = this

					const formData = new FormData()
					formData.append('uuid', this.$firebase.user.uid)

					this.$axios
						.post(this.$varuna.endPoints.getFontpayment, formData, { timeout: 60000 })
						.then(function (response) {
							if (response.data.payment_flag == '1') {
								app.fontPaymented = true
							}
						})
						.catch(function (error) {
						}).finally(function () {
						})

				}
			})
		}
	},
	watch: {},
	created: function () {
		this.getFontpayment()
	},
	mounted: function () { }
}
</script>
